import { socket } from '../..';
import { store } from '@shared/redux';
import { generatedApi } from '@shared/api';

export const handleClientFieldsChanged = () => {
  return socket.onMessage('CLIENT_FIELDS_CHANGED', (payload) => {
    const clientId = payload.client_id;
    const changedFields = payload.fields ?? [];
    if (typeof clientId !== 'number' || !changedFields.length) return;

    const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
      store.getState(),
      'getClientFieldsClientFieldsGet',
    );
    let hasQueryForClient = false;
    let shouldRefetchClientFields = false;

    cachedArgs?.forEach((args) => {
      if ((args as { clientId?: number })?.clientId !== clientId) {
        return;
      }
      hasQueryForClient = true;

      store.dispatch(
        generatedApi.util.updateQueryData('getClientFieldsClientFieldsGet', args, (draft) => {
          const draftAgents = draft as Array<{
            client_fields?: Array<{ agent_field_id: number; value: string }>;
          }>;

          for (const changed of changedFields) {
            for (const agent of draftAgents) {
              const field = agent.client_fields?.find(
                (item) => item.agent_field_id === changed.agent_field_id,
              );

              if (field) {
                field.value = changed.value;
                break;
              }
            }

            const hasFieldInCache = draftAgents.some((agent) =>
              agent.client_fields?.some((item) => item.agent_field_id === changed.agent_field_id),
            );

            if (!hasFieldInCache) {
              shouldRefetchClientFields = true;
            }
          }
        }),
      );
    });

    if (hasQueryForClient && shouldRefetchClientFields) {
      store.dispatch(
        generatedApi.endpoints.getClientFieldsClientFieldsGet.initiate(
          { clientId },
          {
            forceRefetch: true,
            subscribe: false,
          },
        ),
      );
    }
  });
};
